import { webStorage } from 'sidecar-utility-library'

import { isActionRelevant } from './utils'

/**
 * When we make the request for IPInfo, we should check if that info is already
 * available in webStorage and pre-populate with that as soon as possible.
 */
export const locKeys = ['city', 'country', 'lat', 'lon', 'zip']
export const hydrateIpInfo = () => next => action => {
  if (!isActionRelevant(action, /FETCH_INITIAL_SETUP_REQUEST/))
    return next(action)
  if (!action.payload || !action.payload.location) return next(action)

  action.payload = action.payload || {}
  locKeys.forEach(key => {
    const item = webStorage.getItem(key)
    if (item) {
      action.payload.location[key] = item
    }
  })

  return next(action)
}

/**
 * When IP info is returned from the server, we should store it in webStorage so
 * that the app has access to things like City, State, Country, Lat, Lon
 */
export const storeIpInfo = () => next => action => {
  if (!isActionRelevant(action, /FETCH_INITIAL_SETUP_SUCCESS/))
    return next(action)
  if (!action.payload) return next(action)

  const rawLocation = action.payload.location || {}
  const location = {
    ...rawLocation,
    lon: rawLocation.lng || rawLocation.lon,
    zip: rawLocation.postalCode || rawLocation.zip,
  }
  // normalize the location params before we save them.
  delete location.lng
  delete location.postalCode

  const nextAction = {
    ...action,
    payload: {
      ...action.payload,
      location,
    },
  }

  Object.keys(location).forEach(k => {
    webStorage.setItem(k, location[k])
  })

  return next(nextAction)
}
